const INITIAL_STATE = null;

export function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case "_OVERRIDE_CLOCK":
            return action.payload;
        default:
            return state;
    }
}

export function overrideClock(clock) {
    return { type: "_OVERRIDE_CLOCK", payload: clock };
}
